import type { FaireProductEntity } from "../../entity_types/product";

export const p_36afngmp3v: FaireProductEntity = {
  token: "p_36afngmp3v",
  type: "product",
  name: "Toggi Fine European Wafers Hazelnut 1.75oz 24 ct Tray",
  brandToken: "b_et6a66kd2z",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9bc89a71bb9133bb7b17e78f715f5dd3ccff1c56234db4ade8efd67739064853.png",
  galleryImageUrls: [],
  priceDollars: 55.42,
  description:
    "Toggi Fine European Wafers Hazelnut offers a rich hazelnut flavor paired with a light, crispy texture. Each 1.75oz wafer is crafted with high-quality ingredients and individually wrapped to maintain freshness. The 24 ct tray provides a convenient option for stocking up or sharing. Ideal for enjoying as a snack, dessert, or alongside your favorite beverage.",
  tags: [],
  msrpDollars: 110.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:30:24.840Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
